module.exports = __webpack_public_path__ + "static/img/battleReportBg2.d73c52bd.png";